<template>
  <div id="deviceinfo">
    <div class="top">
      <div class="back" ref="back" @click="back">{{ $t("index.back") }}</div>
      <!--       {{ deviceInfo.warnType }}：{{ deviceInfo.warn }} -->
    </div>
    <div class="infocontent">
      <div class="left">
        <div class="card" id="info">
          <div class="card-head">
            <div>{{ $t("index.deviceInfo") }}</div>
          </div>
          <div class="card-content">
            <!-- 左上组件 -->
            <InfoComponent :key="datekey" :devicein="deviceInfo" />
          </div>
        </div>
        <div class="card" id="taskinfo">
          <div class="card-head">
            <div>{{ $t("index.workInfo") }}</div>
          </div>
          <div class="card-content">
            <!-- 左下组件 -->
            <TaskInfo :devicein="deviceInfo" />
          </div>
        </div>
      </div>
      <div class="right">
        <div class="card" id="task">
          <div class="card-head">
            <div>{{ $t("index.deviceMonitor") }}</div>
            <div>{{ $t("index.workedTime") }}：{{ deviceInfo.workedTime }}</div>
          </div>
          <div class="card-content">
            <!-- 右上角设备监控组件 -->
            <TaskComponent
              :key="datekey"
              :devicein="deviceInfo"
              :stateInfo="deviceInfo.stateInfo"
              :stateColor="deviceInfo.stateColor"
            />
          </div>
        </div>
        <div class="card" id="realtime">
          <div class="card-head">
            <div>{{ $t("index.realTime") }}</div>
          </div>
          <div class="card-content">
            <!-- 右下角组件 -->
            <RealtimeData
              :key="datekey"
              :devicein="deviceInfo"
              :speed="deviceInfo.speed"
              :pressure="deviceInfo.pressure"
              :power="deviceInfo.power"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount, getCurrentInstance } from "vue";
import { useRouter, useRoute } from "vue-router";

import InfoComponent from "./DevicePage_ws/BasicInfo.vue";
import TaskComponent from "./DevicePage_ws/DeviceTask.vue";
import RealtimeData from "./DevicePage_ws/RealtimeData.vue";
import TaskInfo from "./DevicePage_ws/TaskInfo.vue";
import axios from "axios";
import { message } from "ant-design-vue";

import VueDatePicker from "@vuepic/vue-datepicker";
import "@vuepic/vue-datepicker/dist/main.css";
import "@/mqttws31.min";

const user = ref({});
let datekey = Date.now();

const router = useRouter();
let route = useRoute();
let orderNumber = route.params.orderNumber;

var globalWebsocket = null; //声明一个全局的websocket对象
var sendWs;

user.value = JSON.parse(localStorage.getItem("user"));

let deviceInfo = ref({
  id: "1",
  name: "设备1",
  deviceType: "sheet",
  state: "4",
  stateCode: "9",
  stateInfo: "离线",
  schedule: 0,
  stateColor: "#0064c8",
  x: "0",
  y: "0",
  z: "0",
  w: "0",
  height: "0",
  punchingNum: "0",
  punchingTime: "0",
  workedTime: "00:00:0",
  taskFile: "E:bdproj",
  cutLeng: "0",
  emptyLength: "0",
  cutTime: "0",
  emptyTime: "0",
  percent: "0%",
  left: 0,
  speed: 0,
  power: 0,
  pressure: 0,
  startTime: "00:00:00",
  endTime: "00:00:00",
  completedCount: "0",
});
console.log("设备号：",route.params.orderNumber)
if (route.params.orderNumber) {
  axios
    .post("api/Machine/GetMachineTables", {
      OrderNumber: route.params.orderNumber,
    })
    .then((response) => {
      if (response.data.code != 200) {
        message.error(response.data.info);
      } else {
        let res = response.data.ReturnData[0];
		console.log("设备参数:",res)
        deviceInfo.value.id = res.EquipmentId;
        deviceInfo.value.name = route.params.orderNumber;
        deviceInfo.value.deviceType = route.params.type;
        deviceInfo.value.ordernumber = route.params.orderNumber;
      }
    })
    .catch((error) => {
      console.error(error);
    })
    .finally(() => {
      GetEquipmentState(deviceInfo.value.id);
    });
} else {
  handleWsData(test);
}

function GetstockUrl() {
  return "wss.bodor.com";
}

function GetEquipmentState(equipmentid) {
  axios
    .post("api/User/GetUsers", {
      account: "admin",
    })
    .then((response) => {
      if (response.data.code != 200) {
        message.error(response.data.info);
      } else {
        var userId = user.value.UserId;
		console.log("用户id:",userId);
        const options = {
          rejectUnauthorized: false, // 禁用证书验证
        };

        const host =
          "wss://" +
          GetstockUrl() +
          ":8866/DataService/?" +
          userId +
          "?2?" +
          equipmentid +
          "";
        console.log(host);
        if (equipmentid != undefined) {
          var wsImpl = window.WebSocket || window.MozWebSocket;
          window.ws = new wsImpl(host); // 从cookie中获取

          //当WebSocket创建成功时，触发onopen事件
          ws.onopen = function () {
            console.log("创建成功");
            globalWebsocket = ws;
            //发送请求
            sendwebSocket(equipmentid);
          };

          //当客户端收到服务端发来的消息时，触发onmessage事件，参数e.data包含server传递过来的数据
          ws.onmessage = function (evt) {
            console.log(evt.data);
            handleWsData(evt.data);
            datekey = Date.now();
          };
          // 关闭时回调 当客户端收到服务端发送的关闭连接请求时，触发onclose事件
          ws.onclose = function () {
            console.log("已关闭");
            clearInterval(sendWs);
            deviceInfo.value.state = "4";
            datekey = Date.now();
          };
          //如果出现连接、处理、接收、发送数据失败的时候触发onerror事件
          ws.onerror = function (e) {
            console.log(e);
            deviceInfo.value.state = "4";
            datekey = Date.now();
          };
        }
      }
    })
    .catch((error) => {
      console.error(error);
    });
}

//发送socket获取数据
function sendwebSocket(order) {
  if (sendWs) {
    clearInterval(sendWs);
  } //发送的设备号标识到服务器多个，发送分割用？分割
  /*   globalWebsocket.send(
    "1:1:" +
      order +
      ":GroupQuery:Ch0.Axes[1].Position?Ch0.Axes[0].Position?Ch0.Axes[2].Position?Axes.W.Position?Ch0.State?Generic.Frp?Auto.Percent?Blow.OutPressure?Spindle.LaserPower?Laser.FileName?Shunt.V?Follow.FollowHeight?AutoStatistics.PunchingNum?AutoStatistics.PunchingTime?Ch0.Auto.Statistics.CuttingLength?Ch0.Auto.Statistics.G00Length?AutoStatistics.DisplayPage.CuttingTime?AutoStatistics.DisplayPage.G00Time?AutoStatistics.DisplayPage.TotalTime?Ch0.Auto.Statistics.StartTime?Ch0.Auto.Statistics.EndTime?Ch0.Auto.Statistics.CompletedCount"
  ); */ sendWs = setInterval(
    function () {
      console.log("发送数据");
      globalWebsocket.send(
        "1:1:" +
          order +
          ":GroupQuery:Ch0.Axes[1].Position?Ch0.Axes[0].Position?Ch0.Axes[2].Position?Axes.W.Position?Ch0.State?Generic.Frp?Auto.Percent?Blow.OutPressure?Spindle.LaserPower?Laser.FileName?Shunt.V?Follow.FollowHeight?AutoStatistics.PunchingNum?AutoStatistics.PunchingTime?Ch0.Auto.Statistics.CuttingLength?Ch0.Auto.Statistics.G00Length?AutoStatistics.DisplayPage.CuttingTime?AutoStatistics.DisplayPage.G00Time?AutoStatistics.DisplayPage.TotalTime?Ch0.Auto.Statistics.StartTime?Ch0.Auto.Statistics.EndTime?Ch0.Auto.Statistics.CompletedCount"
      ); //发送的设备号标识到服务器多个，发送分割用？分割
    },
    2000
  );
}

Date.prototype.Format = function (fmt) {
  //author: meizz
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    S: this.getMilliseconds(), //毫秒
  };
  if (/(y+)/.test(fmt))
    fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt))
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
  return fmt;
};

const test =
  "1:Ch0.Axes[1].Position:0,Ch0.Axes[0].Position:0,Ch0.Axes[2].Position:0,Axes.W.Position:0,Ch0.State:3,Generic.Frp:100,Auto.Percent:3,Blow.OutPressure:null,Blow.OutPressure:,Spindle.LaserPower:0,Laser.FileName:无标题.ncex,Shunt.V:0,Follow.FollowHeight:1,AutoStatistics.PunchingNum:0,AutoStatistics.PunchingTime:0,Ch0.Auto.Statistics.CuttingLength:0,Ch0.Auto.Statistics.G00Length:0,AutoStatistics.DisplayPage.CuttingTime:00:00:06.339,AutoStatistics.DisplayPage.G00Time:00:00:01.969,AutoStatistics.DisplayPage.TotalTime:00:00:09.126,Ch0.Auto.Statistics.StartTime:2023/6/29 15:47:47,Ch0.Auto.Statistics.EndTime:0001/1/1 0:00:00,Ch0.Auto.Statistics.CompletedCount:0";
8;
onBeforeUnmount(() => {
  ws.close();
  if (sendWs) {
    clearInterval(sendWs);
  }
});

onMounted(() => {
  if (sendWs) {
    clearInterval(sendWs);
  }
});

function handleWsData(wsData) {
  if (wsData) {
    var str = wsData; //接收返回的字符串进行解析
    //str = "1:Ch0.Axes[1].Position:0,Ch0.Axes[0].Position:0,Ch0.State:1";
    var index = str.indexOf(":");
    var result = str.substr(index + 1, str.length);
    var arrydata = result.split(",");
    if (arrydata.length > 0) {
      for (var i = 0; i < arrydata.length; i++) {
        var data = "";

        data = arrydata[i]; // Ch0.Axes[1].Position: 0
        var key = data.substr(0, data.indexOf(":")); //Ch0.Axes[1].Position  //截取：之前
        var value = data.substr(data.indexOf(":") + 1, data.length); //0 //截取：之后
        switch (key) {
          case "Ch0.State": //0，1 空闲  2开始中 3运行 4暂停中 5暂停 6停止中 7急停中 8急停   //设备状态
            deviceInfo.value.stateCode = value;
            if (value == 0 || value == 1) {
              //空闲黄色
              deviceInfo.value.state = "0";
              deviceInfo.value.stateInfo = "空闲";
              deviceInfo.value.stateColor = "#e0bb00";
            } else if (value == 2) {
              //绿色
              deviceInfo.value.state = "1";
              deviceInfo.value.stateInfo = "开始中";
              deviceInfo.value.stateColor = "#009431";
            } else if (value == 3) {
              //绿色
              deviceInfo.value.state = "1";
              deviceInfo.value.stateInfo = "运行";
              deviceInfo.value.stateColor = "#009431";
            } else if (value == 4) {
              //暂停黄色
              deviceInfo.value.state = "2";
              deviceInfo.value.stateInfo = "暂停中";
              deviceInfo.value.stateColor = "#e0bb00";
            } else if (value == 5) {
              //暂停黄色
              deviceInfo.value.state = "2";
              deviceInfo.value.stateInfo = "暂停";
              deviceInfo.value.stateColor = "#e0bb00";
            } else if (value == 6) {
              //暂停黄色
              deviceInfo.value.state = "2";
              deviceInfo.value.stateInfo = "停止中";
              deviceInfo.value.stateColor = "#e0bb00";
            } else if (value == 7) {
              //红色
              deviceInfo.value.state = "3";
              deviceInfo.value.stateInfo = "急停中";
              deviceInfo.value.stateColor = "#e00000";
            } else if (value == 8) {
              //红色
              deviceInfo.value.state = "3";
              deviceInfo.value.stateInfo = "急停";
              deviceInfo.value.stateColor = "#e00000";
            } else {
              //离线灰色
              deviceInfo.value.state = "4";
              deviceInfo.value.stateInfo = "离线";
              deviceInfo.value.stateColor = "#0064c8";
            }
            break;
          case "Ch0.Axes[1].Position": //X轴
            deviceInfo.value.x = value == "null" || value == "" ? 0 : parseInt(value);
            break;
          case "Ch0.Axes[0].Position": //Y轴
            deviceInfo.value.y = value == "null" || value == "" ? 0 : parseInt(value);
            break;
          case "Ch0.Axes[2].Position": //Z轴
            deviceInfo.value.z = value == "null" || value == "" ? 0 : parseInt(value);
            break;
          case "Axes.W.Position": //W轴
            deviceInfo.value.w = value == "null" || value == "" ? 0 : parseInt(value);
            break;
          case "Generic.Frp": //给进倍率
            deviceInfo.value.percent =
              value == "null" || value == "" ? "0%" : parseInt(value) + "%";
            break;
          case "Auto.Percent": //加工进度
            deviceInfo.value.schedule = parseInt(value);
            break;
          case "Shunt.V": //设备速度
            deviceInfo.value.speed = value == "null" || value == "" ? 0 : parseInt(value);
            break;
          case "Blow.OutPressure": //设备功率
            deviceInfo.value.power = value == "null" || value == "" ? 0 : parseInt(value);
            break;
          case "Spindle.LaserPower": //设备电压
            deviceInfo.value.pressure =
              value == "null" || value == "" ? 0 : parseInt(value);
            break;
          case "Laser.FileName": //文件名称
            deviceInfo.value.taskFile = value;
            break;
          case "Laser.Follow.FollowHeight": //高度
            deviceInfo.value.height =
              value == "null" || value == "" ? 0 : parseInt(value);
            break;
          case "AutoStatistics.PunchingNum": //穿孔数
            deviceInfo.value.punchingNum = value;
            break;
          case "AutoStatistics.PunchingTime": //穿孔时间
            deviceInfo.value.punchingTime = value;
            break;
          case "Ch0.Auto.Statistics.CuttingLength": //切割长度
            deviceInfo.value.cutLeng =
              value == "null" || value == "" ? 0 : parseInt(value);
            break;
          case "Ch0.Auto.Statistics.G00Length": //空移长度
            deviceInfo.value.emptyLength =
              value == "null" || value == "" ? 0 : parseInt(value);
            break;
          case "AutoStatistics.DisplayPage.CuttingTime": //切割时间
            deviceInfo.value.cutTime = value;
            break;
          case "AutoStatistics.DisplayPage.G00Time": //空移时间
            deviceInfo.value.emptyTime = value;
            break;
          case "AutoStatistics.DisplayPage.TotalTime": //加工时间
            deviceInfo.value.workedTime = value;
            break;
          case "Ch0.Auto.Statistics.StartTime": //开始加工时间
            deviceInfo.value.startTime = value;
            break;
          case "Ch0.Auto.Statistics.EndTime": //结束加工时间
            deviceInfo.value.endTime = value;
            break;
          case "Ch0.Auto.Statistics.CompletedCount": //零件数量
            deviceInfo.value.completedCount = value;
            break;
          case "1":
            break;
          case "ServerMsg":
            deviceInfo.value.state = "4";
            deviceInfo.value.stateInfo = "离线";
            deviceInfo.value.stateColor = "#0064c8";
            deviceInfo.value.power = 0;
            deviceInfo.value.pressure = 0;
            deviceInfo.value.speed = 0;
            deviceInfo.value.x = 0;
            deviceInfo.value.y = 0;
            deviceInfo.value.z = 0;
            deviceInfo.value.w = 0;
            deviceInfo.value.schedule = 0;
            deviceInfo.value.workedTime = 0;
            deviceInfo.value.startTime = "00:00:00";
            deviceInfo.value.endTime = "00:00:00";
            break;
          default:
            break;
        }
      }
    } else {
      deviceInfo.value.state = "4";
      deviceInfo.value.stateInfo = "离线";
      deviceInfo.value.stateColor = "#0064c8";
    }
  }
  console.log(deviceInfo.value);
}

const date1 = ref();
const date2 = ref();

const back = () => {
  router.push("/index/device");
};
</script>

<style scoped>
#deviceinfo {
  width: 100%;
  height: 100%;
  padding: 0px 0px;
  background-color: #f7f9fa;
  position: relative;
}
.top {
  width: 100%;
  height: 50px;
  text-align: center;
  line-height: 50px;
  background-color: white;
  color: black;
  font-weight: bold;
  font-size: 18px;
  position: relative;
  color: #fac858;
}
.back {
  height: 100%;
  line-height: 50px;
  color: #5470c6;
  cursor: pointer;
  position: absolute;
  left: 25px;
}
.infocontent {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 20px;
}
.left {
  width: 49.5%;
}
.right {
  width: 49.5%;
}
.line {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.card {
  box-sizing: border-box;
  border: none;
  border-radius: 4px;
  -webkit-box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  box-shadow: 0 1px 2px 1px rgba(0, 0, 0, 0.16);
  margin-bottom: 15px;
  height: auto;
  overflow: visible;
  transition: all 0.4s;
  font-size: 14px;
  background-color: white;
  min-width: 450px;
}
.card:hover {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.16), 0 1px 2px 1px rgba(0, 0, 0, 0.16);
}
.card-head {
  width: 100%;
  align-items: center;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 12px 15px;
}
.card-content {
  width: 100%;
  min-height: 50px;
  padding: 15px;
}
.datebox {
  height: 100%;
  display: flex;
  align-items: center;
}
.datepicker {
  width: 200px;
  height: 30px;
  cursor: pointer;
  background-color: white;
  background-image: none;
  border-radius: 4px;
  position: relative;
}
p {
  margin: 0px;
}
#hours {
  width: 49%;
  height: 380px;
}
#hoursline {
  width: 49%;
  height: 380px;
}
#realtime {
  /* min-width: 900px;
  height: 450px; */
}
#taskinfo {
  /* height: 450px; */
}
#repairreport {
  height: 275px;
}
#repairreport .card-content {
  height: 275px;
  padding: 0px 15px;
}
</style>
